import { nanoid } from "@reduxjs/toolkit";
import { api } from "../../../app/api";

export interface GetUnionByIdPayload {
  unionId: string;
}

export interface GetPaymentInfosByUnionIdPayload extends GetUnionByIdPayload {}

export interface CreateTradeUnionPayload extends Union {}

export interface UpdateTradeUnionPayload extends Union {}

export interface UnionPaymentInfo {
  eezyCompanyId: string;
  name: string;
  paymentReferenceTemplate: string;
}

export interface IdParentIdPair {
  id: string;
  parentId: string | null;
}

export interface DeleteTradeUnionsPayload {
  tradeUnions: IdParentIdPair[];
}

export interface UnionListItem {
  id: string;
  name: string | null;
  acronym: string | null;
  tradeUnionNumber: string | null;
}

interface Address {
  street: string | null;
  zip: string | null;
  city: string | null;
}

export interface BankAccount {
  iban: string | null;
  bic: string | null;
  overrideBankAccount: boolean;
}

export interface UnionPayment {
  year: number | null;
  validFrom?: string | null;
  validTo?: string | null;
  percentage?: string | null;
  fixedAmount?: string | null;
}

export interface UnionTermsOfPayment {
  overridePayments: boolean;
  payments: UnionPayment[];
}

export interface UnionEezyPaymentInfo {
  name: string | null;
  eezyCompanyId: string | null;
  paymentReferenceTemplate: string | null;
}

export interface Union {
  id: string;
  parentId: string | null;
  acronym: string | null;
  name: string | null;
  businessId: string | null;
  tradeUnionNumber: string | null;
  phoneNumber: string | null;
  address: Address;
  termsOfPayment: UnionTermsOfPayment;
  bankAccount: BankAccount;
  unionPaymentInfo: UnionEezyPaymentInfo[];
  localUnions: UnionListItem[];
  lastFetched?: number;
}

export const initialUnion = {
  id: "",
  parentId: null,
  acronym: null,
  name: null,
  businessId: null,
  tradeUnionNumber: null,
  phoneNumber: null,
  address: {
    street: "",
    zip: "",
    city: "",
  },
  termsOfPayment: {
    overridePayments: false,
    payments: [],
  },
  bankAccount: {
    iban: "",
    bic: "",
    overrideBankAccount: false,
  },
  unionPaymentInfo: [],
  localUnions: [],
};

export const runGetUnions = (payload: any) => {
  return api.post("/projections/qry/tradeUnions", {
    requestId: nanoid(),
    auth: true,
    body: payload,
  });
};

export const runGetUnionById = (payload: any) => {
  return api.get("/projections/qry/tradeUnionById", {
    requestId: nanoid(),
    auth: true,
    queryParams: payload,
  });
};

export const runCreateTradeUnion = (payload: any) => {
  return api.post("/invoicing/cmd/createTradeUnion", {
    requestId: nanoid(),
    auth: true,
    body: payload,
  });
};

export const runUpdateTradeUnion = (payload: any) => {
  return api.post("/invoicing/cmd/updateTradeUnion", {
    requestId: nanoid(),
    auth: true,
    body: payload,
  });
};

export const runDeleteTradeUnions = (payload: any) => {
  return api.post("/invoicing/cmd/deleteTradeUnions", {
    requestId: nanoid(),
    auth: true,
    body: payload,
  });
};

export const runGetPaymentInfosByUnionId = (payload: any) => {
  return api.get<UnionPaymentInfo[]>("/projections/qry/paymentInfosByUnionId", {
    requestId: nanoid(),
    auth: true,
    queryParams: payload,
  });
};
